import ProficienciesPaneCustomProficiency from './ProficienciesPaneCustomProficiency';

export default ProficienciesPaneCustomProficiency;
export { ProficienciesPaneCustomProficiency };
